module.exports = {
      id: "filter-icon-usage",
      viewBox: "0 0 13 14",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#filter-icon",
      toString: function () {
        return this.url;
      }
    }